<mat-card class="m-auto padding12 home-card boxshadowgrey">
    <div>
        <button mat-icon-button color="primary" class="back-button" routerLink="/data">
            <mat-icon>arrow_back</mat-icon>
        </button>
    </div>
    <div class="content">
        <mat-card-title-group class="home-card" id="title">
            <mat-card-title>{{ "PARAMETER.HEADER" | translate}}</mat-card-title>
            <div class="allButton">
                <ng-container *ngIf="this.gatewayConnectionService.gatewayConnected == true && this.loaded == true">
                    <button mat-raised-button class="addAll" (click)="addAll()" #tooltip="matTooltip" matTooltip="{{'PARAMETER.BTN_ALL_TIP' | translate }}" matTooltipPosition="below">{{"PARAMETER.BTN_ALL" | translate}}</button>
                    <button mat-raised-button class="resetAll" (click)="resetAll()" #tooltip="matTooltip" matTooltip="{{'PARAMETER.BTN_ALL_RESET_TIP' | translate }}" matTooltipPosition="below">{{"PARAMETER.BTN_ALL_RESET" | translate}}</button>
                </ng-container>
            </div>
        </mat-card-title-group>

        <mat-card-content id="content">
            <div class="home-card" id="content">
                <ng-container *ngIf="this.gatewayConnectionService.gatewayConnected == false"
                        >{{"MESSAGES.CONN_WAITING" | translate}}</ng-container>
    
                <ng-container *ngIf="this.loaded != true && this.gatewayConnectionService.gatewayConnected == true">
                    <div class="loading" id="wrapper">
                        <mat-progress-spinner mode="indeterminate" color="primary" class="loading" id="spinner"></mat-progress-spinner>
                    </div>
                </ng-container>
    
                <ng-container *ngIf="this.gatewayConnectionService.gatewayConnected == true && this.loaded == true">
                    <div class="table">
                        <table mat-table [dataSource]="dataSet" class="table">
                            <ng-container matColumnDef="name">
                                <th mat-header-cell *matHeaderCellDef></th>
                                <td mat-cell *matCellDef="let element" #tooltip="matTooltip" matTooltip="{{element.info}}" matTooltipPosition="left">{{ element.name }}</td>
                            </ng-container>
                    
                            <ng-container matColumnDef="curr_value">
                                <th mat-header-cell *matHeaderCellDef>{{"PARAMETER.CURRENT" | translate}}</th>
                                <td mat-cell *matCellDef="let element"> 
                                    <div *ngIf=this.fetchedElements.includes(element.name)>{{ element.currentValue }} {{ element.unit }}</div>
                                    <div *ngIf=!this.fetchedElements.includes(element.name)>
                                        <div class="loading" id="wrapper">
                                            <mat-progress-spinner mode="indeterminate" color="primary" class="loading" id="spinner" diameter="35"></mat-progress-spinner>
                                        </div>
                                    </div>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="default_value">
                                <th mat-header-cell *matHeaderCellDef>{{"PARAMETER.DEFAULT" | translate}}</th>
                                <td mat-cell *matCellDef="let element"> {{ element.defaultValue }} {{ element.unit}}</td>
                            </ng-container>

                            <ng-container matColumnDef="input_value">
                                <th mat-header-cell *matHeaderCellDef>{{"PARAMETER.INPUT" | translate}}</th>
                                <td mat-cell *matCellDef="let element">
                                    <!-- RANGE INPUT -->
                                    <ng-container *ngIf="element.valueOptions.inputType == 'range'">
                                        <mat-form-field class="input_value_field" id="input" subscriptSizing="dynamic" subscriptSizing="dynamic" #tooltip="matTooltip" matTooltip="{{ 'OPTIONS.TOOLTIP.SELECT' | translate}}" matTooltipPosition="below">
                                            <mat-label>{{"PARAMETER.INPUT_INSTRUCTION_R" | translate}}</mat-label>
                                            <input
                                                matInput
                                                type="number"
                                                [min]=element.valueOptions.range[0]
                                                [max]=element.valueOptions.range[1]
                                                placeholder="Value between {{element.valueOptions.range[0]}} and {{element.valueOptions.range[1]}}"
                                                [(ngModel)]="element.chosenValue"
                                                name="inputValue"
                                                (keyup)="checkRange(element, element.chosenValue, element.valueOptions.range[0], element.valueOptions.range[1])"
                                                (change)="setValidation(element)"
                                            />
                                        </mat-form-field>
                                    </ng-container>

                                    <!-- SELECTION -->
                                    <ng-container *ngIf="element.valueOptions.inputType == 'select'">
                                        <mat-form-field subscriptSizing="dynamic" #tooltip="matTooltip" matTooltip="{{ 'OPTIONS.TOOLTIP.SELECT' | translate}}" matTooltipPosition="below">
                                            <mat-label>{{"PARAMETER.INPUT_INSTRUCTION_S" | translate}}</mat-label>
                                            <mat-select [(value)]="element.chosenValue" (selectionChange)="setValidation(element)" >
                                                <mat-option *ngFor="let option of element.valueOptions.inputValue" [value]="option"> {{ option }}</mat-option>
                                           </mat-select>
                                        </mat-form-field>
                                    </ng-container>

                                    <!-- BINÄR SELECTION -->
                                    <ng-container *ngIf="element.valueOptions.inputType == 'binary'">
                                        <mat-button-toggle-group [(ngModel)]="element.chosenValue" class="toggle" (change)="setValidation(element)" #tooltip="matTooltip" matTooltip="{{ 'OPTIONS.TOOLTIP.BINAR' | translate}}" matTooltipPosition="below">
                                            <mat-button-toggle *ngFor="let option of element.valueOptions.inputValue" [value]="option">{{ option }}</mat-button-toggle>
                                        </mat-button-toggle-group>
                                    </ng-container>

                                </td>
                            </ng-container>
            
                            <ng-container matColumnDef="btn_set">
                                <th mat-header-cell *matHeaderCellDef></th>
                                <td mat-cell *matCellDef="let element">
                                    <button mat-flat-button color="accent" (click)="changeValue(element)" [disabled]="!element.valid">{{"PARAMETER.BTN_SET" | translate}}</button>
                                </td>
                            </ng-container>

                            <ng-container matColumnDef="btn_default">
                                <th mat-header-cell *matHeaderCellDef></th>
                                <td mat-cell *matCellDef="let element">
                                    <button mat-flat-button class="default" color="accent" (click)="setDefaultValue(element)">{{"PARAMETER.BTN_DEFAULT" | translate}}</button>
                                </td>
                            </ng-container>
                    
                            <tr mat-header-row *matHeaderRowDef="displayColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayColumns;"></tr>
                        </table>
                    </div>
                </ng-container>
                
            </div>
        </mat-card-content>
        
    </div>
    
</mat-card>
